import type { UserPreferencesDto } from './connector-next-schemas';
import { parseJsonBody, sendOutsideSaveAttempt } from './saveHttp';

/**
 * Hand-written client for the connector-next user preferences write. The
 * write replaces the whole value and returns it as stored, with its next
 * version.
 */

/** Replaces the caller's own preferences. */
export async function putUserPreferences(
    startupView: string,
    ifMatch: string
): Promise<UserPreferencesDto> {
    const response = await sendOutsideSaveAttempt(
        '/api/preferences/me',
        {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ startupView }),
        },
        ifMatch
    );
    return parseJsonBody<UserPreferencesDto>(response);
}
